<template>
  <div class="page">
    <template v-if="mobileStyle">
      <MLivesLive v-if="activeLive" />
      <MLivesMain v-else />
    </template>
    <template v-else>
      <LivesLive v-if="activeLive" />
      <LivesMain v-else :windowWidth="windowWidth" />
    </template>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';
  import LivesMain from '@/components/lives/LivesMain.vue';
  import LivesLive from '@/components/lives/LivesLive.vue';
  import MLivesMain from '@/components/lives/MLivesMain.vue';
  import MLivesLive from '@/components/lives/MLivesLive.vue';

  export default {
    components: {
      LivesMain,
      LivesLive,
      MLivesMain,
      MLivesLive,
    },
    data() {
      return {
        windowWidth: 1024,
        updateTimer: null,
      };
    },
    computed: {
      ...mapState('Lives', ['activeLive']),
      mobileStyle() {
        return this.windowWidth < 800;
      },
    },
    methods: {
      ...mapMutations(['showLoading', 'hideLoading']),
      ...mapActions('Lives', ['updateCats', 'updateLives']),
      updateWindowWidth() {
        this.windowWidth = window.innerWidth;
      },
      myUpdateLives() {
        this.updateTimer = setTimeout(this.updateLives, 300000);
      },
    },
    mounted() {
      const { showLoading, hideLoading, updateCats, updateLives } = this;
      showLoading();
      Promise.all([updateCats(), updateLives()]).finally(() => {
        hideLoading();
        this.myUpdateLives();
      });
      window.addEventListener('resize', this.updateWindowWidth);
      this.updateWindowWidth();
    },
    destroyed() {
      window.removeEventListener('resize', this.updateWindowWidth);
      if (this.updateTimer) {
        clearTimeout(this.updateTimer);
        this.updateTimer = null;
      }
    },
  };
</script>

<style lang="scss"></style>
